import { SalesPages } from "burde";
import { D3Selection } from "svg/draw/draw-calendar";
import { Selection } from "d3";
import { BleedSize, CalendarSizeDimensions } from "svg/constants";

const draw = (
    svg: D3Selection,
    coverInfo: string,
    calendarDimensions: CalendarSizeDimensions,
) => {
    let image = coverInfo;
    var background = svg.append("g").classed("background-content", true);
    background
        .append("svg:image")
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", calendarDimensions.svgWidth)
        .attr("height", calendarDimensions.svgHeight)
        .attr(
            "xlink:href",
            `images/sales/${image}?width=${calendarDimensions.svgWidth}&height=${calendarDimensions.svgHeight}`,
        )
        .attr("preserveAspectRatio", "xMidYMid slice");

    let content = background
        .append("g")
        .attr("transform", `translate(${BleedSize}, ${BleedSize})`)
        .classed("main-content", true);
};

const drawSalesPage = (
    container: Selection<any, any, any, any>,
    salesPages: SalesPages,
    calendarDimensions: CalendarSizeDimensions,
) => {
    const leftSvg = container
        .append("svg")
        .attr("width", "100%")
        .attr("height", "100%")
        .attr("preserveAspectRatio", "xMinYMin slice")
        .attr(
            "viewBox",
            `0 0 ${calendarDimensions.svgWidth} ${calendarDimensions.svgHeight}`,
        )
        .classed("svg-content", true);

    const rightSvg = container
        .append("svg")
        .attr("width", "100%")
        .attr("height", "100%")
        .attr("preserveAspectRatio", "xMinYMin slice")
        .attr(
            "viewBox",
            `0 0 ${calendarDimensions.svgWidth} ${calendarDimensions.svgHeight}`,
        )
        .classed("svg-content", true)
        .attr("xmlns", "http://www.w3.org/2000/svg");

    draw(leftSvg, `${salesPages.name}-left.svg`, calendarDimensions);
    draw(rightSvg, `${salesPages.name}-right.svg`, calendarDimensions);
};

export { drawSalesPage };
